module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-8"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("UZY")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("’")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ALARM")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("SOUNDED")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v("from her cell phone. She sat up. Stretched. Rubbed her eyes. It had taken a while, but she’d finally fallen asleep. Good thing too. She had to work tonight at the nursing home.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She turned off the alarm and stood. Her eyes fell on the yellow notice. Oh, right. She’d forgotten about that. Two weeks to clean up the backyard shouldn’t be hard, right? Just a matter of getting the trash bags to the curb on pick up day. Straighten a few things. No big deal.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After she made her afternoon cup of coffee and added plenty of cream and sugar, she pried open the sliding door that led to the deck. Stood and observed the yard. Tried to see what Mr. Stone had seen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Yep, those trash bags were waiting by the garage. Had to be at least a dozen of them. But she worked on collection days, and by the time she got home, she wanted to sleep. Not haul trash to the curb. And that’s if they hadn’t already picked up her neighborhood. She could transport them herself to the dump, and probably would have to, but that meant more time taken out of her already busy, upside down schedule. Four twelve hour days left only three to catch up on everything, and that was if she was lucky enough to have those three days off instead of getting called in at the last minute to cover a shift at the nursing home. Not that she minded. It was easier to keep busy. Less time to think. To remember. To grieve.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then there was the Camaro that had been parked in the backyard since Suzy had been eight or nine. Shortly before her dad had left her mother and her, he’d driven it there to work on the engine. But he never had. And so it sat, almost twenty years later. She wondered if she could even find the keys for it. Maybe in the glass bowl Mama had kept on her dresser.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She took her coffee with her and approached the rusted heap. It had been her dad’s pride and joy once. The classic car he had wanted to restore. But he couldn’t fix it any more than he could deal with the people in his life. Instead, he’d left it behind for them to deal with along with everything else.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d asked Mama why he hadn’t stayed, but answers had been rare. He’d never called, never sent a gift for her birthday or Christmas. As if once he’d gone, they no longer existed to him. Part of her wondered how much of his absence was possibly due to her mom keeping him away. Maybe he’d wanted to see her, but Mama wouldn’t let him. Or maybe he just hadn’t cared. Suzy had tried finding him when Mama got sick, but it was as if he’d disappeared completely that spring morning when he’d said he was leaving for work and never came home.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shielded her eyes and peered into the passenger side window. Noticed evidence that some animal had made it a temporary home. Shredded paper nested about a foot wide. And, if the soft mewls were any indication, the resident had left her babies behind.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suzy set the coffee mug on the roof of the car and pulled on the handle to open the door. With much effort, it wrenched free. She popped her head in and wrinkled her nose at the stench. She carefully kneeled on the passenger seat and bent forward. Between the driver’s seat and the control pedals, three gray and white kittens huddled together. They couldn’t have been more than a few days, maybe a week, old. Their eyes still closed. So tiny. So helpless.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suzy glanced around the car for something to use to carry them inside. Nothing. Despite her mom’s lackluster housecleaning skills, the interior of the car was empty. She’d have to go find something. “Okay, guys. I’ll be right back. Don’t go anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She unfolded herself from the car, slammed the door shut and grabbed her coffee mug from the car roof. She ran to the house and once inside, placed the mug in the sink before searching through piles of stuff until she found an old wicker Easter basket that still had plastic green grass inside. Figuring that the grass would act as a cushion, she placed a clean tea towel over the grass and sprinted back to the car.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The driver’s side door took less effort to open. Probably because she’d found her mom sitting in the seat more than once over the years. She stooped down and carefully removed each kitten and placed it in the basket. Took her precious cargo into the house. Found a baby bottle in one of the boxes. Washed the bottle since dust coated the surface and then filled it with milk. On the couch she took turns feeding each kitten and stroking its head.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As she did so, she wondered what had happened to their mom. They were orphans, abandoned just like her, and that connection made her heart break for them. “It’s okay. I’ll make sure that someone takes care of you. Promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They looked little more than skeletons covered in fur, and they would need more care than she could give. Propping the bottle on a pillow so that the last kitten could still eat, she dialed her best girlfriend Presley’s number at the animal rescue. “Hey, Pres. I’ve got some little ones for you. Do you have room?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A big sigh on the other end. “I’ll find room. What have you got?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The cutest little kittens in the world.” Suzy looked them over again and smiled as they rolled around each other trying to find a comfortable sleeping position. Almost as if they didn’t want to be separated from each other for very long. “Well, they will be once they get some meat on their bones. And they probably need shots. I found them abandoned in Daddy’s car.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Any sign of the mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suzy shook her head and petted the two kittens who had fallen asleep after eating their fill. “Orphans. Just like me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Funny how that word still hurt after six months. She kept the smile on her face. As if her best friend could see her through the phone. “I can bring them in before I go to work tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, okay.” The line stayed silent. “Suze, are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("How many times had she been asked that question since her mom died? She gave the standard answer. Better that than admit she missed Mama so much it ached. “Perfect. Wait till you see these cuties.” She smiled brighter. “They’re going to break your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s what I’m afraid of.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Once the last kitten had eaten and fallen asleep, Suzy took her shower then got ready for work. She had an hour or so before she needed to be at the nursing home, so she could stay at the animal rescue and help out with the animals. She knew Presley was swamped with strays, which meant less time to walk them and care for them. Suzy could volunteer to do that for her friend.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She nodded. That’s what she’d do. And she’d deal with the backyard tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("EVEN")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HOURS")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(". W")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ILL")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v("paced the waiting room of the hospital. They’d been there over seven hours with no word. No diagnosis. No solution.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tori sat on a plastic chair, her head bent over a romance novel, but he could see that she’d been on the same page for the last thirty minutes. She was just as worried as he was.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where’s the doctor? It shouldn’t be taking this long.” He stood in front of Tori and crossed his arms over his chest. Waiting for her to look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Instead, she kept her eyes on the page. “Stop watching the clock and pacing, Will. It’ll go faster.” She looked up and patted the empty chair beside hers. “Now sit. Read a magazine. Or go get us some snacks. We haven’t had lunch, and I’m starving.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shook his head. “If I’m not here when the doctor comes in....”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then I’ll talk to him. Not the end of the world.” She put her bookmark in the book and laid it beside her. “Or how about I’ll go get us some food. I need something.” She stood and grabbed her purse from the floor. “Snickers bar? Mountain Dew? Doritos?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fine. Whatever”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He took out his wallet and handed her a twenty which she waved away. “I’ve got this. And I’ll call my neighbor Teresa and ask if she can pick up the boys from school.” She checked her watch. “Hopefully I’ll catch her before she leaves to get her son Noah.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She flipped her phone open and dialed as she walked out of the waiting room. Will watched her leave then took a seat in her abandoned chair. He noticed her romance novel and picked it up. Flipped through it. Read a particularly racy scene and raised his eyebrows. What was going on with his sister? First the dyed hair. Now the sexy book? Maybe she was finally over her ex.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("About time.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When Tori returned with a bulging plastic bag from the gift shop, he held up the book to her. “You’re reading this?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She nodded and took the seat next to him, before handing him a wrapped sandwich and pop can. “Teresa recommended it. It’s actually quite good.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He noted the bookmark was more than halfway through the book. “Obviously.” He unwrapped the sandwich and toasted her with it. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Anything for you.” She popped the tab on her drink then took a sip. “Still no word?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will swallowed his bite and shook his head. “It’s gotta be soon, right? I mean how long can they make us wait for answers?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Teresa said she’d keep the boys at her house as long as I need her to.” She took a deep breath. “She’s been a good friend. Especially since the divorce.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will put one arm around her. “The hits keep coming, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She swiped her eyes with the back of her hand. “You don’t know how hard it is being a single mom. There’s no one around to give me a hand. To answer the nonstop questions. Or deal with the increasing emotions. To tell them no. And then there’s the hormones.” She shuddered as if a cold finger had run up her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He bumped her shoulder. “Whenever you need me, just call.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know. But I’ve got to do this on my own. I can’t depend on you all the time.” She straightened in her seat. “Stones know how to get the job done.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She unwrapped her sandwich and took a bite. He did the same, and they sat in silence for a while. The only sound other families chatting while they waited for news and a talk show on the television in the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After eating their late lunch, Will gathered the trash and threw it out in the receptacle. Tori returned to her book, so he checked his email on his phone and waited for word on his mom.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A doctor in blue-green scrubs entered the room. “Stone family?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("About time. Will and Tori stood and held hands as the doctor approached. “Why don’t we step into the privacy room?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uh oh. That couldn’t be good.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They followed her into the room. Tori sat on the bench while he remained standing. He could take whatever news it was. He could be strong. For his mom. For Tori.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For himself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m Dr. Westphal, and I’ve been supervising your mom’s care since they brought her in.” She consulted her tablet. “She arrived in the emergency room exhibiting pain and a possible bone fracture.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will frowned. “She broke something? It’s not her heart? I mean, we assumed...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dr. Westphal looked up at him. “The more persistent problem right now is her fractured hip. We need to get her into surgery.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You bet. I’ll sign whatever form you need me to.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mrs. Stone has already given her consent and will go into surgery to repair the fracture shortly after you see her.” Dr. Westphal sighed. “But the problem is after surgery.” She looked up from the tablet at first Will, then Tori. “She’ll be in the hospital for a few days but then will need long term care. Physical therapy. Possibly a hip replacement. And when she’s stronger, chemotherapy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will lost the strength of his legs and sat next to Tori. No. Not this.”Cancer then.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re still running tests, but it appears the cancer is attacking her bones. Making them brittle and fragile.” Dr. Westphal took a seat in front of them. “A simple fall should not break bones, even in a woman your mother’s age.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tori started to cry softly beside him. He held her hand and squeezed. Their mom had cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He closed his eyes to keep the panic from invading his mind. When he opened them, he gave a short nod. “How bad is it? I mean, how long...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor shrugged. “We won’t know any answers until more tests can be run. Let’s focus on repairing the hip first.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will nodded again. “We can see her?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor stood. “I’ll take you to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As they followed the doctor down the white, sterile hallway, Will turned to Tori. “No tears in front of mom. She needs our strength right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tori nodded and wiped her face. “I know the drill.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dr. Westphal led them through a maze of hospital beds and curtained off areas. Eventually she pushed a curtain aside to reveal his mom hooked up to monitors and an IV. She looked tiny in the huge bed. Fragile. Lost. She opened her eyes and gave them a smile. “My babies.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor left them, pulling the curtain closed behind her. Will moved to his mom’s side and took her hand. His emotions were pressing on him, but he’d deal with them later. “Are you in any pain?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eva shook her head and pointed to the IV. “They’re giving me the good stuff.” She pointed to the end of her bed. “Let’s talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They need to take you to surgery.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They will.” She pointed at the bed again. “I want to spend time with you before they take me away. Now sit.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tori took a seat on one side of her. Afraid to jostle his mom and cause pain, Will stood beside her and held her hand. Besides, he could control himself standing. Be a good soldier like his dad and the Marines had trained him. He tensed his muscles, ready for whatever followed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His mom’s expression softened. “The doctor told you, didn’t she? She asked if she could, and I said yes, but I’d hoped—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll fight this, Mom. I’ll get the best doctors. Specialists.” Emotion threatened to close his throat, and he swallowed it right away. “Stones don’t go down without a fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His mom nodded. “Or they die trying.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tori started crying, holding their mom’s hand to her cheek. Will kept swallowing, unable to say anything. Unable to offer anything. Finally, his mom gave a soft smile. “Sorry. I didn’t mean it like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will cleared his throat. “It’s okay, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A nurse pulled the curtain open. “They’re ready for you, Mrs. Stone.” She turned to Will. “I can escort you to the surgical waiting room.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tori leaned over and kissed her mom on the cheek. “Lovey.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lovey.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will kissed his mom and rested his forehead on hers. “Lovey.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lovey.” She patted his cheek. “Everything is going to be fine. I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Fine. Right.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A team of nurses surrounded his mom’s hospital bed then wheeled her away. The first nurse led them to a different waiting room than before, but it looked much the same. “Surgery should be about two hours. Dr. Westphal will keep you updated.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will sighed as he took a seat near the window. Tori fished in her purse for her cell phone. “I’ll just call Teresa and tell her I’ll be late.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She stepped away, leaving Will with his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His mom had cancer. Life wasn’t ever going to be the same after today. No matter what they needed to do to fight this, they’d do it. If she needed chemo, bone marrow transplant, whatever, she would get it. She had to get better because their family didn’t work without her in it. She was their center.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stood and resumed his pacing. How was he supposed to move on from this? Would they survive? He glanced at his phone. He should call Joanie and Carol. They had a right to know even if they didn’t choose to be involved. He started to dial the first number.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("UZY")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("PARKED")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HER")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v("bright yellow VW bug in front of the animal rescue shelter. She must have been a good girl that day to get such a prime parking spot. Despite her intention to arrive early, she would only have enough time to drop off the kittens and then hurry to work before she was late. Again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hooked her arm through the Easter basket and carried it with her to the front door. The receptionist Thoramae spotted her and rushed to open the door for her. “Hey, Suzy. More critters for us?” The older woman with tight permed curls peeked into the basket and smiled. “Aren’t they the cutest fur balls?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They just need some TLC.” Suzy squeezed past Thoramae. “Is Presley in her office?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You bet. Can’t get her to leave.” Thoramae returned to her spot behind the reception desk. “She’s been asking for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks.” Suzy looked down into her basket. Two of the kittens slept while the third licked its paw. “You’re gonna love Pres. She’ll help you get big and strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Presley sat at her desk and looked up when Suzy walked in. “I’d ask if you always talk to yourself, but I know the answer to that one.” She came around the desk and gave Suzy a hug. “How are you doing today?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fine.” Suzy avoided her friend’s eyes and placed the basket on Presley’s desk. “Tell me you can help these guys.” Presley picked one of the kittens and held him up. “He’s awfully scrawny. Good thing you found them when you did. Temperatures are supposed to fall over the weekend. They could have frozen out there.” She held the kitten close to her chest and stroked his head. “With a little time and a lot of food, they should be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suzy wilted with relief into a chair. “Good. I can’t deal with any more loss.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you sure you’re okay?” Presley put down the kitten and turned her attention to Suzy. Probed her with the same intensity she usually reserved for her animal patients. “We haven’t hung out lately. Or talked much.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, you know my work schedule. Midnight shifts don’t help a social life.” Suzy gave a forced chuckle. “I’m fine. Tired, maybe. They had me working six days last week.” Her friend seemed to accept her words. At least for now. Suzy leaned in closer to Presley. “But I did meet a guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Presley clapped her hands and perched on the edge of her desk. “When? How? Details, details.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Actually he showed up at my front door.” Suzy let that sink in then laughed at Presley’s expression. “He’s some kind of code enforcement inspector who knew Mama. Told her she had to clean up the backyard.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can figure out how well that went over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suzy rolled her eyes. “No kidding. He’s given me two weeks to clean it up. Or else.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Or else what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suzy shrugged. “They charge me to get someone else to clean it up, I guess.” She thought about the mess. “It might be easier if they did. It’s not like they’d take the house from me. Right?” She wished she sounded more confident.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You can’t afford that, Suze. Besides, I can help you.” Her friend crossed her legs at her ankles. For a moment, Suzy envied her long legs since she’d been born with short ones. Pres leaned back on her desk. “Anytime. Just ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But your job here...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Presley laughed and shook her head. “Despite what Thoramae says, I do take time off from here occasionally.” She bit her lip and watched Suzy. “I notice you talked about what he did. But not what he looks like. That good, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suzy fanned herself. “Hotter than hot. In an uptight, strait-laced kind of way.” She thought back to Mr. Stone. “He kind of reminds me of that guy who plays James Bond now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Presley smiled wider. “Yummy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No kidding.” Suzy stood and hitched her purse higher on her shoulder. She glanced at the clock behind Presley’s desk and sighed. “I’ve got to get going, but...” She glanced at the kittens one more time. “You’ll keep me updated?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Absolutely.” Presley hugged her again. “And I mean it. I’ll help you. You don’t have to do this on your own, Suze.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know.” That’s what she said, but she didn’t quite believe it.")])])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 84
// module chunks = 0